import { useObjectActionMutation } from '../api/object'
import { Button } from '../components/button'

export function ActionBar({ id }: { id: string }) {
	const { mutate: changeType } = useObjectActionMutation('client', id, 'change-type')
	return (
		<div className="flex items-center justify-between gap-4 mb-5">
			<h2 className="text-lg font-semibold">Detail zákazníka</h2>
			<Button variant="PRIMARY" onPress={() => changeType({})}>
				Změnit typ
			</Button>
		</div>
	)
}
